export default __webpack_public_path__ + "static/media/gos.191618f8.mp3";